import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state:{
    currentPage:sessionStorage.getItem('currPage')||'/tree',
    userInfo:sessionStorage.getItem('userInfo')?JSON.parse(sessionStorage.getItem('userInfo')):null
  },
  mutations:{
    changePage(state,page){
      sessionStorage.setItem('currPage',page)
      state.currentPage = page
    },
    updataUserInfo(state,userInfo){
      sessionStorage.setItem('userInfo',JSON.stringify(userInfo))
      state.userInfo = userInfo
    }
  },
  actions:{
    
  },
  modules:{

  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js